import './style.css';
import App from './App';
import TouchClickPolyfill from './utils/TouchClickPolyfill';

document.querySelector('#home_button').addEventListener('click', () => {
  window.location.href = window.location.origin;
});

new TouchClickPolyfill();

new App();
